export const STATUS_SUBSCRIBED = 'subscribed';
export const STATUS_TRIAL = 'trial';
export const PLAN_LD_V2_STARTER_BUNDLE = 'plan-liondesk-v2-starter-bundle';
export const PLAN_LD_V2_PROPLUS_BUNDLE = 'plan-liondesk-v2-pro+-bundle';
export const PLAN_LD_V2_ELITE_BUNDLE = 'plan-liondesk-v2-elite-bundle';
export const BUNDLE_SKUS = [
  PLAN_LD_V2_STARTER_BUNDLE,
  PLAN_LD_V2_PROPLUS_BUNDLE,
  PLAN_LD_V2_ELITE_BUNDLE,
];
export const MLS_AOR_SKUS = [
  'plan-liondesk-CRMLS-monthly',
  'plan-liondesk-real-comp-monthly',
  'plan-liondesk-SDMLS-monthly',
  'plan-liondesk-statewide-monthly',
  'plan-liondesk-BayEast-monthly',
  'plan-liondesk-CCAR-monthly',
  'plan-liondesk-REColorado-monthly',
  'liondesk-Alaska_MLS-monthly',
  'plan-liondesk-v2-CAR-monthly',
  'carolina-one',
  'plan-v2-liondesk-entitlement',
];
